import { useState, useEffect, useMemo } from "react";

const useUserAccount = (instance) => {
  const [account, setAccount] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setLoading(true);
    const currentAccount = instance.getActiveAccount();
    setAccount(currentAccount || null);
    setLoading(false);
  }, [instance]);

  const { userName, userRole, project, nameParts } = useMemo(() => {
    if (!account) {
      return {
        userName: "",
        userRole: "",
        project: "",
        nameParts: [],
      };
    }

    const { username, idTokenClaims, name } = account;
    const roles = idTokenClaims?.roles || [];
    const role = roles[0] || "";
    const proj = role && role !== "devops" ? role : "";

    return {
      userName: username || "",
      userRole: role,
      project: proj,
      nameParts: name ? name.split(" ") : [],
    };
  }, [account]);

  return { userName, userRole, project, nameParts, loading };
};

export default useUserAccount;
